import React from "react";
import { toast } from "react-toastify";
import { GoogleLogin } from "react-google-login";

const clientId =
  "356394307734-0576bulqkuvvtgtvbsr1v4mm24o1vcad.apps.googleusercontent.com";
// const onSuccess = (res) => {
//   console.log("Login Success Current User", res.profileObj);
//   console.log("Login Success Current User email", res.profileObj.email);
  
//   localStorage.setItem("emailId",res.profileObj.email);
//   localStorage.setItem("name",res.profileObj.name);
//   localStorage.setItem("loginMethod", "GOOGLE");
//   localStorage.setItem("isLoggedIn", true);  
//   toast.success("Google Login Success"); 

// };
// const onFailure = (res) => {
//   console.log("Login Failed", res);
//   localStorage.removeItem("loginMethod");
//   localStorage.setItem("isLoggedIn", false);
//   localStorage.setItem("emailId",'');
//   localStorage.setItem("name",'');
//   toast.error("Google Login Failed");
// };

// const Login = (props) => {
//   return (
//     <>
//       <div id="LoginInButton">
//         <GoogleLogin
//           clientId={clientId}
//           buttonText="Login"
//           onSuccess={onSuccess}
//           onFailure={onFailure}
//           cookiePolicy={"single_host_origin"}
//           isSignedIn={false}
//         />

//         {/* <div id="facebookButton">
//           <button onClick={props.handleFacebookLogin}>
     
//             <img src="./facebook.png" width="40px" /> <span>Login</span>
//           </button>
//         </div> */}
//       </div>
//     </>
//   );
// };

// export default Login;


const Login = (props) => {
  const onSuccess = (res) => {
    console.log("Login Success Current User", res.profileObj);
    props.onGoogleLoginSuccess(res.profileObj); // Call the function passed from App
  };

  const onFailure = (res) => {
    
    localStorage.removeItem("loginMethod");
    localStorage.setItem("isLoggedIn", false);
    localStorage.setItem("emailId", '');
    localStorage.setItem("name", '');
    // toast.error("Google Login Failed");
  };

  return (
    <div id="LoginInButton">
      <GoogleLogin
        clientId={clientId}
        buttonText="Login"
        onSuccess={onSuccess}
        onFailure={onFailure}
        cookiePolicy={"single_host_origin"}
        isSignedIn={false}
      />
    </div>
  );
};
export default Login;